import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AvailabilityService } from 'src/app/services/jrni/availability.service';
import { BasketService } from 'src/app/services/jrni/basket.service';
import { DepartmentService } from 'src/app/services/jrni/department.service';
import { ServicesService } from 'src/app/services/jrni/services.service';
import { AlertService } from 'src/app/_alert';
import { DatastoreService } from 'src/app/services/datastore.service';
import { MemberService } from 'src/app/services/jrni/member.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { interval } from 'rxjs';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
  selectedDepartment;
  pageTitle;
  calendarPageText;
  minDate;
  maxDate;
  selectedDate: Date;
  currentDate: Date;
  selectedService;
  selectedLocation;
  slots: [];
  selectedSlot;
  availableDays: any;
  component: String;
  bookingsLimit: String;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  subscription: any;

  constructor(
    private router: Router,
    private departmentService: DepartmentService,
    private servicesService: ServicesService,
    private availabilityService: AvailabilityService,
    private alertService: AlertService,
    private basketService: BasketService,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private datastoreService: DatastoreService,
    private memberService: MemberService
  ) {
  }

  routerGoBack() {
    this.memberService.getMember().then(async member => {
      if (member) {
        this.router.navigate(['/departments']);
      } else {
        this.router.navigate(['/departments']);
      }
    });
  }

  restartJourney() {
    this.router.navigate(['/access']);
  }

  ngOnInit() {
    this.scrollToTop();


    this.selectedDepartment = this.datastoreService.selectedDepartment;
    if (this.selectedDepartment) {
      const source = interval(500); // repetedly check to see if we need to add avaiable/unavaiable to the aria (which is sued by screen readers)
      this.subscription = source.subscribe(val => {
        this.spinner.show()
      })
      this.component = "calendar";
      this.departmentService.getLocation().then(selectedLocation => {
        this.selectedLocation = selectedLocation
      });

      let parentDepartment = this.datastoreService.parentDepartment;

      // this.selectedLocation = this.departmentService.getLocation();

      // Set the current date to today for the calendar to default to today
      this.currentDate = new Date();
      this.selectedDate = this.currentDate;

      // Get the configurable data
      if (parentDepartment.hasOwnProperty('extra')) {
        // Set the title on the login page to the title from the business question
        parentDepartment.extra.hasOwnProperty('calendar_page_title') ? this.pageTitle = parentDepartment.extra.calendar_page_title : this.pageTitle = "Calendar title not set";
        // Set the extra text on the page to the text taken from the business question
        parentDepartment.extra.hasOwnProperty('calendar_page_text') ? this.calendarPageText = parentDepartment.extra.calendar_page_text : null;
      }

      // Retrieve the selected service
      this.servicesService.get().then(service => {
        this.selectedService = service;

        // Clear the basket
        // this.basketService.deleteAllBaskets(this.selectedDepartment).catch((err) => {
        //   this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
        // });

      });
      this.spinner.show()

    } else {
      this.restartJourney();
    }

  }

  continue() {
    this.alertService.clear();
    this.availabilityService.getSelectedSlot().then(async slot => {
      if (slot) {
        // Store the selected date
        this.datastoreService.selectedDate = this.selectedDate;
        // Store the selected slot
        this.datastoreService.selectedSlot = slot;
        this.spinner.show();
        try {
          await this.basketService.deleteAllBaskets(this.selectedDepartment)
        } catch (err) {
          console.log(err)
        }
        this.memberService.getMember().then(async member => {
          console.log(member)
          if (member === undefined) {
            localStorage.setItem('auth_token', "")
            localStorage.setItem('loginObject', "")
            sessionStorage.setItem("auth_token","")
          }
          console.log(localStorage.getItem("auth_token"))
          this.basketService.createBasket(this.selectedDepartment).then(
            async (basket) => {
              this.basketService.currentBasket = basket;
              if (await this.addItem()) {
                this.router.navigate(['/booking-details']);

              } else {
                this.spinner.hide();
                this.scrollToTop();
              }
            })
        })
      } else {
        this.alertService.warn(this.translateService.instant('CALENDAR.SLOT_WARNING'));
        this.scrollToTop();
      }
    });
  }


  async addItem() {
    // Get the selected slot from the previous page
    const selectedSlot = await this.availabilityService.getSelectedSlot();
    let bookingAnswers = []

    // Add item to the basket
    const res = await this.basketService.addItem(
      this.selectedLocation,
      this.selectedService.id,
      this.selectedService.durations[0],
      selectedSlot.datetime,
      bookingAnswers
    )
    if (res == "failed") {
      // If conflict/409
      this.alertService.error(this.translateService.instant('SUMMARY.INVALID_SLOT'));
      // this.spinner.hide();
      return false
    }
    this.datastoreService.basketItem = res;
    console.log(this.datastoreService.basketItem)
    return true
  }


  // scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }

  test(event: Event) {
    console.log("test")
    this.subscription.unsubscribe();
    this.spinner.hide()
  }
}
